'use client';

// Client-boundary re-exports for Constellation composites that ship without a
// "use client" directive (Button's button.js, Card's card.js — their `.Root`
// parts have one, the composites don't). Rendered from a Server Component, the
// composite runs in the RSC graph and the Radix `Slottable` marker it wraps
// children in is flattened during serialization; the client-side `Slot` behind
// `asChild` then throws "Slot failed to slot onto its children", 500ing the
// whole route. Importing through this boundary keeps the composite in the
// client graph. Use these instead of the package import for `asChild` usage in
// Server Components.
//
// Caveat: the slotted child must not be a Server Component that suspends (e.g.
// the i18n `Link` from '@/src/i18n/navigation', which awaits getLocale()) — it
// serializes as a lazy node that Radix Slot's `Slottable child=...` path fails
// to resolve. Use `next/link` or a plain element as the child instead.
export { Button, Card, TextButton } from '@zillow/constellation-10';
